import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {Http, Headers, Request, Response, RequestOptionsArgs} from '@angular/http';
import {SessionService} from './session/shared/session/session-service/session.service';
import {SETTINGS} from '../../clpbp-app.settings';

@Injectable()
export class HttpClient {

  public urlPrefix: string;

  constructor(private http: Http, private sessionService: SessionService) {
    this.urlPrefix = `${SETTINGS.API.URL}/${SETTINGS.API.NAME_SPACE}`;
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    options = this.setDefaultContentType(options, options.body);
    return this.http.request(`${this.urlPrefix}/${url}`, options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    return this.http.get(`${this.urlPrefix}/${url}`, options);
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    options = this.setDefaultContentType(options, body);
    return this.http.post(`${this.urlPrefix}/${url}`, body, options);
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    options = this.setDefaultContentType(options, body);
    return this.http.put(`${this.urlPrefix}/${url}`, body, options);
  }

  delete(url: string, body?: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    if (body) { options.body = body; }
    options = this.setDefaultContentType(options, body);
    return this.http.delete(`${this.urlPrefix}/${url}`, options);
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    options = this.setDefaultContentType(options, body);
    return this.http.patch(`${this.urlPrefix}/${url}`, body, options);
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setAuthHeaders(options);
    return this.http.head(`${this.urlPrefix}/${url}`, options);
  }

  private setDefaultContentType(options: RequestOptionsArgs, body: any) {
    if (!options) { options = {}; }
    if (!options.headers) { options.headers = new Headers(); }
    //  A server error is issued if Content-Type is missing for requests with body.
    // So default to application/json if request has a body and no Content-Type header set.
    if (body && !options.headers.has('Content-Type')) {
      options.headers.set('Content-Type', 'application/json');
    }

    return options;
  }

  private setAuthHeaders(options: RequestOptionsArgs) {
    if (!options) { options = {}; }
    if (!options.headers) { options.headers = new Headers(); }

    let token = (this.sessionService.authenticated &&
                 this.sessionService.data &&
                 this.sessionService.data.authData.token) ?
                 this.sessionService.data.authData.token : null;
    if (token) { options.headers.set('Authorization', `Bearer ${token}`); }

    return options;
  }
}
